import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

export const SaveUser = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/User/AddUser`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "ADD_USERS", payload: data });
    return obj;
  } catch (err) {
    console.error("Error adding product details:", err);
  }
};

export const submitContactUs = (obj) => async () => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/User/SubmitContactUs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    return await response.json();
  } catch (err) {
    console.error("Error submitting Contect Us details:", err);
  }
};

export const checkIsAdmin = (uid) => async (dispatch) => {
  let obj = {
    UID: uid,
  };
  try {
    const response = await apiFetch(`${API_BASE_URL}/User/checkIsAdmin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "SET_IS_ADMIN", payload: data });
    return data;
  } catch (err) {
    dispatch({ type: "SET_IS_ADMIN", payload: false });
    console.error("Error adding product details:", err);
  }
};
